import { useState, useEffect } from "react";
import HospitalCustomPaginaion from "../../utils/HospitalPaginationUtil";
import EditSubAdmin from "./EditSubAdmin";
import AddSubAdmin from "./AddSubAdmin";
import { getlist, updateUser } from "../../services/AdminServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import RemoveIcon from "../../assets/deleteIcon.svg";
import EditIcon from "../../assets/editIcon.svg";
import AddIcon from "../../assets/addMoreIcon.svg";
import EditPencil from "../../assets/editPencilIcon.svg";
import { toast } from "react-toastify";

const HospitalPersonaSubAdmin = () => {
  const [subAdminList, setSubAdminList] = useState(null);
  const [addSubAdminModal, setAddSubAdminModal] = useState(false);
  const [editInfo, setEditInfo] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 10;

  const getSubAdminList = async () => {
    setLoading(true);
    try {
      const res = await getlist();
      setSubAdminList(res?.data?.Users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  const handleDeleteSubadmin = async (id) => {
    const data = { userid: id, status: "DELETED" };
    try {
      const res = await updateUser(data);
      toast.success("Sub admin deleted successfully");
      await getSubAdminList();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // ✅ NEW — Active / Inactive Toggle Handler
  const handleToggleActive = async (user) => {
    const isCurrentlyActive = user.status === "ACTIVE";

    const confirmation = window.confirm(
      `Are you sure you want to ${
        isCurrentlyActive ? "deactivate" : "activate"
      } this sub-admin?`
    );
    if (!confirmation) return;

    const data = {
      userid: user.id,
      status: isCurrentlyActive ? "DISABLE" : "ACTIVE", // toggle status
    };

    try {
      const res = await updateUser(data);
      toast.success("Status updated successfully");
      await getSubAdminList();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getSubAdminList();
  }, []);

  return (
    <div>
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%]"
      >
        Home / Dashboard / Sub Admin
      </div>

      <div className="flex justify-between items-center">
        <div className="w-fit text-[30px] 2xl:text-[50px] mt-[12px] 2xl:mt-[30px]">
          Sub Admin
        </div>

        <div
          className="w-fit flex items-center gap-5 text-[12px] 2xl:text-sm text-white bg-[#017C71] uppercase px-4 2xl:px-5 py-[12px] 2xl:py-[15px] rounded-full cursor-pointer"
          onClick={() => setAddSubAdminModal(true)}
        >
          Add Sub-Admin{" "}
          <img
            src={AddIcon}
            alt="add-icon"
            width={18}
            height={18}
            className="h-[14px] w-[14px] 2xl:h-[18px] 2xl:w-[18px]"
          />
        </div>
      </div>

      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-1 2xl:mt-4 rounded-[30px] min-h-[70vh]"
      >
        <div className="text-[30px] 2xl:text-[50px]">List of Sub-Admins</div>

        <div className="bg-white py-[30px] px-[38px] mt-[30px] rounded-[15px]">
          <div className="flex justify-between">
            <div className=" w-[80%] grid grid-cols-5 text-sm font-semibold">
              <div>Name</div>
              <div>Email</div>
              <div>Phone</div>
              <div>Status</div>
              <div>Role</div>
            </div>
            <div>Action</div>
          </div>

          <div
            style={{ borderTop: "1px solid #0000001A", marginBlock: "30px" }}
          />

          {subAdminList
            ?.filter((user) => user.status !== "DELETED")
            ?.map((user, idx) => {
              const isActive = user.status === "ACTIVE";

              return (
                <div
                  key={idx}
                  className="flex justify-between items-center mt-8"
                >
                  <div className="w-[80%] grid grid-cols-5 text-sm leading-[18px]">
                    <div>{user.fullName}</div>
                    <div>{user.email}</div>
                    <div>{user.phone}</div>

                    {/* ✅ Toggle Switch UI */}
                    <div>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={isActive}
                          onChange={() => handleToggleActive(user)}
                        />
                        <div
                          className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer 
                          peer-checked:bg-green-500 relative transition-all"
                        >
                          <span
                            className={`absolute top-[3px] left-[3px] w-5 h-5 bg-white rounded-full transition-all 
                            ${isActive ? "translate-x-5" : ""}`}
                          ></span>
                        </div>
                      </label>
                    </div>
                    <div className="flex items-center gap-1">
                      <div>{user?.userrolemappings[0]?.role?.roleName}</div>
                      <img src={EditPencil} alt="edit-icon-pencil" />
                    </div>
                  </div>

                  <div className="flex gap-2 justify-end items-center cursor-pointer">
                    <div>
                      <img
                        src={RemoveIcon}
                        alt="remove-icon"
                        width={17}
                        height={17}
                        onClick={() =>
                          window.confirm(
                            "Are you sure you want to delete this subadmin?"
                          ) && handleDeleteSubadmin(user.id)
                        }
                      />
                    </div>

                    <div>
                      <img
                        src={EditIcon}
                        alt="edit-icon"
                        onClick={() => setEditInfo(user)}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {addSubAdminModal && (
        <AddSubAdmin
          setOpen={setAddSubAdminModal}
          getSubAdminList={getSubAdminList}
        />
      )}

      {editInfo && (
        <EditSubAdmin
          setOpen={setEditInfo}
          user={editInfo}
          getSubAdminList={getSubAdminList}
        />
      )}
    </div>
  );
};

export default HospitalPersonaSubAdmin;
